import React from "react";
import DocumentHead from "../components/common/DocumentHead";
import ProjectIndex from "../components/projects/ProjectIndex";

/**
 * Archive page at /projekti.
 *
 * @returns {JSX.Element}
 */
function Works() {
  return (
    <>
      <DocumentHead
        title="Projekti — ITArchitecture"
        description="Arhiva projekata studija ITArchitecture: stambeni i poslovni objekti, turistički kompleksi i apartmani u Bosni i Hercegovini."
      />
      <ProjectIndex />
    </>
  );
}

export default Works;
